export const RETRIEVE_QUOTE_TITLE = 'Your Quote';
export const DASHBOARD_PAGE_TITLE = 'Change policy';
export const YOUR_CAR_PAGE_TITLE = 'Car details';
export const YOUR_REGISTRATION_PAGE_TITLE = 'Car registration details';
export const YOUR_ADDRESS_TITLE = 'Address Details';
export const YOUR_POSTAL_ADDRESS_TITLE = 'Postal address details';
export const YOUR_ADDRESSES_TITLE = 'Change your addresses';
export const YOUR_CORRESPONDENCE_ADDRESS_TITLE = 'Your correspondence address';
export const YOUR_DRIVER_PAGE_TITLE = 'Your drivers';
export const STOP_YOUR_RENEWAL = 'Stop your renewal';
export const ADD_DRIVER_PAGE_TITLE = 'Add a driver';
export const PREMIUM_PAGE_TITLE = 'New premium';
export const REVIEW_PAGE_TITLE = 'Review changes';
export const PAYMENT_PAGE_TITLE = 'Payment';
export const CONFIRM_PAGE_TITLE = 'Confirm';
export const ERROR_PAGE_TITLE = 'Error';
export const YOUR_PERSONAL_DETAILS_PAGE_TITLE = 'Your personal details';
export const YOUR_MILEAGE_PAGE_TITLE = 'Your mileage';
export const WHERE_IPARK_MY_CAR_TITLE = 'Change where your car is kept';
export const YOUR_CAR_USAGE_PAGE_TITLE = 'Your car usage';
